import { z } from 'zod';
import type { Account } from './Account';

export class AccountValidator {
    public static validateAll(account: Account): boolean {
        return (
            AccountValidator.isNameValid(account) === '' &&
            AccountValidator.isEmailValid(account) === '' &&
            (AccountValidator.isExpirationDateValid(account) === '' ||
                AccountValidator.hasNoExpirationDate(account))
        );
    }

    public static isNameValid(account: Account): string {
        try {
            z.string().min(2).parse(account.getName());
        } catch (e) {
            return 'Name is too short';
        }
        return '';
    }

    public static isEmailValid(account: Account): string {
        try {
            z.string().email().parse(account.getEmail());
        } catch (e) {
            return 'Invalid email';
        }
        return '';
    }

    public static isExpirationDateValid(account: Account): string {
        try {
            z.string()
                .regex(/^\d{4}-\d{2}-\d{2}$/i)
                .parse(account.getExpirationDate());
        } catch (e) {
            return 'Invalid expiration date';
        }
        return '';
    }

    public static hasNoExpirationDate(account: Account): boolean {
        return account.getExpirationDate() === null;
    }
}
